import { createContext, useContext, useEffect, useRef } from "react";
import Lenis from "lenis";

const LenisCtx = createContext({ current: null });

export const SmoothScroll = ({ children }) => {
  const ref = useRef(null);
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    ref.current = lenis;
    let id;
    const raf = (time) => {
      lenis.raf(time);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
    };
  }, []);
  return <LenisCtx.Provider value={ref}>{children}</LenisCtx.Provider>;
};

export const useScrollTo = () => {
  const ref = useContext(LenisCtx);
  return (target) => {
    const el = typeof target === "string" ? document.querySelector(target) : target;
    if (!el) return;
    if (ref.current) ref.current.scrollTo(el, { offset: -20, duration: 1.6 });
    else el.scrollIntoView({ behavior: "smooth" });
  };
};
